import { buttonStyle, buttonStyleMap } from './buttonClassNameConstants.js';
/** @deprecated */
export const getRegularButtonClasses = ({ className, rounded, version, }) => [
    buttonStyle,
    'border border-transparent inline-block cursor-pointer no-underline focus:border-primary-text focus:border h-fit',
    version ? buttonStyleMap[version] : '',
    rounded ? 'rounded-full' : 'rounded-md',
    className,
].join(' ');
//# sourceMappingURL=getRegularButtonClasses.js.map